import { render, staticRenderFns } from "./activationYinhai.vue?vue&type=template&id=16a3bfa4&scoped=true&"
import script from "./activationYinhai.vue?vue&type=script&lang=ts&"
export * from "./activationYinhai.vue?vue&type=script&lang=ts&"
import style0 from "./activationYinhai.vue?vue&type=style&index=0&id=16a3bfa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3bfa4",
  null
  
)

export default component.exports